import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowLeft, Clock, Mail, Phone } from 'lucide-react';
import BrandLogo from '@/components/BrandLogo';

export default function ContactUs() {
  const EMAIL = 'support@expresssub.com';
  const PHONE_DISPLAY = '1-302-399-4767';
  const PHONE_TEL = '+13023994767';

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="sm" data-testid="contact-back-btn">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back
            </Button>
          </Link>
          <div className="flex items-center gap-2">
            <BrandLogo variant="black" size="sm" />
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-3xl w-full mx-auto px-6 py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Manrope']">
          Contact Us
        </h1>
        <p className="mt-3 text-base sm:text-lg text-slate-600">
          Questions, feedback, or need a hand? Reach us anytime.
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {/* Email */}
          <Card
            className="rounded-2xl border-slate-200 hover:shadow-md transition-shadow"
            data-testid="contact-email-card"
          >
            <CardContent className="p-6">
              <div className="h-12 w-12 rounded-xl bg-emerald-100 text-emerald-700 flex items-center justify-center mb-4">
                <Mail className="h-6 w-6" />
              </div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Manrope']">
                Email
              </h2>
              <p className="text-sm text-slate-500 mt-1">
                We usually reply within one business day.
              </p>
              <a
                href={`mailto:${EMAIL}`}
                className="mt-4 inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-medium text-base break-all"
                data-testid="contact-email-link"
              >
                <Mail className="h-4 w-4 flex-shrink-0" />
                {EMAIL}
              </a>
            </CardContent>
          </Card>

          {/* Phone */}
          <Card
            className="rounded-2xl border-slate-200 hover:shadow-md transition-shadow"
            data-testid="contact-phone-card"
          >
            <CardContent className="p-6">
              <div className="h-12 w-12 rounded-xl bg-slate-900 text-white flex items-center justify-center mb-4">
                <Phone className="h-6 w-6" />
              </div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Manrope']">
                Phone
              </h2>
              <p className="text-sm text-slate-500 mt-1">
                Monday – Friday, 9am – 5pm ET.
              </p>
              <a
                href={`tel:${PHONE_TEL}`}
                className="mt-4 inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-medium text-base"
                data-testid="contact-phone-link"
              >
                <Phone className="h-4 w-4 flex-shrink-0" />
                {PHONE_DISPLAY}
              </a>
            </CardContent>
          </Card>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200 text-center text-sm text-slate-500">
          <div className="flex items-center justify-center gap-4">
            <Link to="/pricing" className="hover:text-emerald-600 underline">
              Pricing
            </Link>
            <span>|</span>
            <Link to="/terms" className="hover:text-emerald-600 underline">
              Terms of Service
            </Link>
            <span>|</span>
            <Link to="/privacy" className="hover:text-emerald-600 underline">
              Privacy Policy
            </Link>
            <span>|</span>
            <Link to="/" className="hover:text-emerald-600 underline">
              Home
            </Link>
          </div>
          <p className="mt-4">© 2026 ExpressSub. All rights reserved.</p>
        </div>
      </main>
    </div>
  );
}
